import React from 'react';
import {
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { AddNotification, EditNotification } from '../../components';

interface ManageNotificationInterface {
  id: string;
}

const ManageNotification: React.FC = () => {
  // const [loader, setLoader] = React.useState(false);
  const { id } = useParams();
  const location = useLocation();
  const editNotification: boolean = location.pathname.includes('editNotification');
  // const [error, setError] = useState('');

  // const handleSubmitForm = async (data: any) => {
  //   if (data.android === false && data.web === false && data.ios === false) {
  //     setError('Please select at least one device');
  //   } else {
  //     setLoader(true);
  //     setError('');
  //     let platform: any = [];
  //     if (data.android) {
  //       platform = [...platform, '1'];
  //     }
  //     if (data.ios) {
  //       platform = [...platform, '2'];
  //     }
  //     if (data.web) {
  //       platform = [...platform, '3'];
  //     }
  //     const form = new FormData();
  //     form.append('file', data.selectedIcon[0]);
  //     Notification.uploadpicture(form).then((res: any) => {
  //       Notification.addNotification({
  //         title: data.title,
  //         message: data.description,
  //         status: 'sent',
  //         image: res.data.data.url,
  //         platforms: platform,
  //       }).then(() => {
  //         setLoader(false);
  //         navigate('/notification');
  //       }).catch((err) => {
  //         setLoader(false);
  //         setError(err.response.data.message);
  //       });
  //     }).catch((err) => {
  //       setLoader(false);
  //       setError(err.response.data.message);
  //     });
  //   }
  // };

  // const handleSaveAsDraft = async (e: any, data: any) => {
  //   e.preventDefault();
  //   if (data.android === false && data.web === false && data.ios === false) {
  //     setError('Please select at least one device');
  //   } else {
  //     setLoader(true);
  //     setError('');
  //     let platform: any = [];
  //     if (data.android) {
  //       platform = [...platform, '1'];
  //     }
  //     if (data.ios) {
  //       platform = [...platform, '2'];
  //     }
  //     if (data.web) {
  //       platform = [...platform, '3'];
  //     }
  //     const form = new FormData();
  //     form.append('file', data.selectedIcon[0]);
  //     Notification.uploadpicture(form).then((res: any) => {
  //       Notification.addNotification({
  //         title: data.title,
  //         message: data.description,
  //         status: 'draft',
  //         image: res.data.data.url,
  //         platforms: platform,
  //       }).then(() => {
  //         setLoader(false);
  //         navigate('/notification');
  //       }).catch((err) => {
  //         setLoader(false);
  //         setError(err.response.data.message);
  //       });
  //     }).catch((err) => {
  //       setLoader(false);
  //       setError(err.response.data.message);
  //     });
  //   }
  // };

  return (
    <>
      {editNotification ? (
        <EditNotification id={id as string} />
      )
        : (
          <AddNotification />
        )}
    </>
  );
};

export default ManageNotification;
